module.exports = __webpack_public_path__ + "static/media/hayley-williams-3.5afc4f19.png";